<!-- Modal de portabilidade -->
<div *ngIf="tipoPropostaPortabilidade" id="app-documento-aditivo" class="documento-aditivo-container m-3">
  <div class="row mb-3 d-flex justify-content-center">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
  </div>
  <h4 class="titulo p-1" style="background: black; color: #fff; border-radius: 10px">
    Exclusivo para beneficiários que pretenderem exercer a portabilidade de carências - RN 438/2018
  </h4>
  <p class="mb-2 mt-2" style="text-align: justify">
    Pelo presente aditivo à proposta de adesão acima identificada, o proponente
    {{ nomeTitular }}, já devidamente qualificado na proposta em referência, manifesta sua CIÊNCIA E CONCORDÂNCIA
    EXPRESSA em solicitar a extinção do vínculo com o plano de origem, no prazo de 05 (cinco) dias a partir da data do
    início da vigência do seu vínculo com o plano de destino, nos termos do artigo 18 da RN 438/2018, ficando ciente
    ainda que, em caso de não cancelamento, o beneficiário estará sujeito ao cumprimento dos períodos de carências
    cabíveis no plano de destino, a critério da Operadora.
  </p>
  <p class="mb-1" style="text-align: justify">
    O prazo para análise e manifestação da operadora de destino quanto a ACEITAÇÃO ou RECUSA da Proposta de Adesão será
    feita no prazo máximo de 10 (dez) dias, contados a partir da data de assinatura.
  </p>
  <p class="mb-1" style="text-align: justify">
    Estou ciente, também, que a RECUSA será encaminhada por escrito, no endereço constante na Proposta de Adesão,
    ensejando o cancelamento da Proposta de Adesão e a devolução de valores eventualmente pagos à título de taxa de
    angariação, caso o proponente não tenha interesse em permanecer no plano com o cumprimento das carências
    contratuais.
  </p>
  <p class="mb-1" style="text-align: justify">
    Durante o prazo de análise da Proposta de Adesão e até que transcorra o prazo de vigência, o proponente e os
    dependentes incluídos NÃO TERÃO DIREITO ÀS COBERTURAS ASSEGURADAS PELO CONTRATO DE DESTINO, ficando vinculado ao
    contrato de origem até seu cancelamento que deve ocorrer até 05 (cinco) dias após o início da vigência do plano ora
    contratado.
  </p>
  <p class="mb-1" style="text-align: justify">
    O proponente declara estar ciente de que na hipótese de contratação familiar em que o direito a portabilidade de
    carências não seja exercido por todos os membros do grupo, o contrato do plano de origem será mantido,
    extinguindo-se o vínculo apenas daqueles que exercerem o referido direito, conforme dispõe o parágrafo único do
    artigo 4º da RN 438/2018.
  </p>
  <p class="mb-1" style="text-align: justify">
    Por fim, o proponente declara estar ciente de que a aceitação da portabilidade de carências está condicionada à
    análise da operadora de destino acerca do preenchimento de todos os requisitos estabelecidos pela RN 438/2018 e
    demais normativos editados pela Agência Nacional de Saúde Suplementar - ANS.
  </p>
</div>

<!-- Modal de sumula 21 -->
<div *ngIf="tipoPropostaSumula" class="documento-aditivo-container m-3">
  <div class="row mb-3 d-flex justify-content-center">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
  </div>
  <div class="row">
    <h4 class="col-12 text-center titulo p-1 mt-1" style="background: black; color: #fff; border-radius: 10px">
      ADITIVO À PROPOSTA DE ADESÃO - SÚMULA 21
    </h4>
  </div>
  <p class="mb-2 mt-2" style="text-align: justify">
    Pelo presente aditivo à proposta de adesão acima identificada, o proponente
    {{ nomeTitular }}, já devidamente qualificado na proposta em referência, manifesta sua CONCORDÂNCIA EXPRESSA em
    extinguir seu vínculo com o plano de origem, sob a condição de que a operadora de destino aceite a referida proposta
    de adesão por Súmula Normativa 21.
  </p>
  <p class="mb-1" style="text-align: justify">
    A Súmula Normativa 21 editada pela Agência Nacional de Saúde Suplementar – ANS, esclarece que devem ser considerados
    todos os prazos de carência e CPT (Cobertura Parcial Temporária) já cumpridos pelos beneficiários que desejarem
    ingressar em um plano de categoria superior dentro da mesma operadora.
  </p>
  <p class="mb-1" style="text-align: justify">
    Apenas pode ser exigido novo prazo de carência para aquelas coberturas e serviços que não estavam previstos no
    contrato anterior, incluindo-se nova rede credenciada de prestadores e diferente padrão de acomodação em internações
    (quarto coletivo ou individual).
  </p>
  <p class="mb-1" style="text-align: justify">
    A Agência ressalta que os prazos de carência já cumpridos não podem ser “recontados”, ou impostos novamente ao
    beneficiário no novo plano de saúde. As novas carências devem obedecer à regra geral no artigo 12, V, ‘b’, da Lei nº
    9.656/98, que prevê o prazo máximo de 180 (cento e oitenta) dias, e devem ser comunicadas previamente ao consumidor,
    pela operadora.
  </p>
  <p class="mb-1" style="text-align: justify">
    O beneficiário declara estar ciente de que a aceitação ou recusa atenderá a critérios técnicos, sendo certo que no
    caso de recusa da Súmula 21, deverão ser cumpridos todos os prazos de carências previstos no contrato ao qual aderiu
    o beneficiário (conforme QUADRO 1 da página 10/11 desta proposta de adesão). Durante o prazo de análise da Proposta
    de Adesão e até que transcorra o prazo de vigência, o proponente e os dependentes incluídos NÃO TERÃO DIREITO ÀS
    COBERTURAS ASSEGURADAS PELO CONTRATO.
  </p>
  <p class="mb-1" style="text-align: justify">
    O proponente declara estar ciente de que na hipótese de contratação familiar em que seu direito a Súmula 21 não seja
    exercido por todos os membros do grupo, o contrato do plano de origem deverá ser mantido, extinguindo-se o vinculo
    apenas daqueles que exercerem o referido direito. O proponente declara estar ciente de que o plano de origem deverá
    estar ativo e adimplente até o último dia que antecede a vigência desta Proposta de Adesão.
  </p>
</div>
